import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// The two typefaces, self-hosted. They used to come from Google Fonts, which
// meant the page made a third-party request on load, which is the one thing the
// privacy copy promises it does not do. Vite fingerprints and emits the woff2
// files alongside everything else, so they are served from this origin and the
// Content-Security-Policy can name a single source for fonts.
//
// Both are variable fonts carrying every subset behind a `unicode-range`, so a
// browser downloads only the ranges the page actually uses. Latin costs 48 KB
// for Inter and 76 KB for Bricolage; the Greek, Cyrillic and Vietnamese files
// sit in the build unread until somebody's name needs them.
//
// Bricolage is imported by its optical-size variant on purpose. It is the
// display face, it runs up to about 60px, and `opsz` is what keeps the large
// headings from looking like body text that has been enlarged. That is what the
// Google Fonts URL asked for too, so this is the same rendering, not a new one.
import '@fontsource-variable/inter';
import '@fontsource-variable/bricolage-grotesque/opsz.css';
import App from './App';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
